import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import slugify from 'react-slugify'

import StoreGroup from './StoreGroup'
import StorePage from './StorePage'

import { sortItemName } from 'Shared/SortItems'
import yn from 'yn'
const capitalize = require('capitalize')

const Store = ({ stores }) => {
  var storesEcommerce = []
  const keepStores = [61719, 61721]
  const removeStores = [61829]

  stores.ecommerce.map((str) => {
    if (!removeStores.includes(str.supplierId)) {
      if (keepStores.includes(str.supplierId)) {
        storesEcommerce.push({ ...str })
      } else {
        var name = sanitizeString(str.name)
        if (name) {
          storesEcommerce.push({ ...str, name: name })
        }
      }
    }
  })

  storesEcommerce = storesEcommerce.sort(sortString)

  return (
    <StorePage>
      <div className='row'>
        <StoreGroup
          items={sortItemName(storesEcommerce, 'name')}
          title='Aqui você encontra as melhores lojas de produtos.'
          hasContent={storesEcommerce.length > 0}
          hasCustomServices={yn(process.env.REACT_APP_STORES_SERVICES)}
          hasCustomVendors={yn(process.env.REACT_APP_STORES_VENDORS)}
        />
      </div>
    </StorePage>
  )
}

Store.propTypes = {
  stores: PropTypes.object.isRequired
}

const sanitizeString = (string) => {
  var str = string || ''
  str = str.toLowerCase().replace('(', '').replace(')', '').replace('ltm', '')
  str = str.replace('ecommerce', '').replace('tatix', '').replace('-', '').replace('satelital', '').replace('itlog', '').trim()
  str = capitalize.words(str)
  str = str === 'Jbl' ? 'JBL' : str
  str = str === 'Mac' ? 'MAC' : str
  return str
}

const sortString = (a, b) => {
  var aName = slugify(a.name, { delimiter: '-' })
  var bName = slugify(b.name, { delimiter: '-' })

  if (aName > bName) {
    return 1
  } else if (bName > aName) {
    return -1
  }
  return 0
}

const mapStateToProps = ({ stores }) => ({
  stores
})

export default connect(
  mapStateToProps,
  null
)(Store)



// WEBPACK FOOTER //
// ./src/features/Store/Store.js